// import queryString from "query-string";
import React, { useContext, useState } from "react";
import {
  CustomButton2,
  CustomDropdownFilter,
  CustomDropdownSearch,
  CustomView,
  //   CustomRadioButtonGroup,
  //   DropDownSearchCities,
  //   DropDownSearchProvinces,
  //   DropDownSearchSuperAgent,
} from "../../../../components";
import Cookies from "js-cookie";
import constants from "../../../../values/constants";
import "./index.scss";
import { useQuery } from "react-query";
import api from "../../../../api";
import values from "../../../../values";
import Context from "../../../../context";
import {
  ICityItem,
  IItem,
  IProvinceItem,
} from "../../../../types/common.interface";
import {
  TICKET_STATUS,
  ticketUserType,
} from "../../../../values/dropdownItems";

const FilterSuperAgent = () => {
  // ============================== Value Validation ================================

  const { requestTicket, setRequestTicket } = React.useContext(
    Context.TicketContext
  );
  const [selectedUserType, setSelectedUserType] = useState<any>();
  const [selectedTicketStatus, setSelectedTicketStatus] = useState<any>();

  // !! ===========================================================================================================
  // !!                                            Start API Call
  // !! -----------------------------------------------------------------------------------------------------------
  // const getAllProvince = useQuery([values.useQueryKeys.getAllProvince], () =>
  //   api.get.common.getAllProvince()
  // );
  // const getAllCity = useQuery(
  //   [values.useQueryKeys.getAllCity, requestTicket?.filters?.province],
  //   () =>
  //     api.get.common.getAllCity({
  //       provinceCode: requestTicket?.filters?.province?.Code,
  //     })
  // );
  // !! -----------------------------------------------------------------------------------------------------------
  // !!                                             End API Call
  // !! ===========================================================================================================

  const userType = Cookies.get(constants.USER.TYPE);

  // ================================== JSX Content ================================

  return (
    <div className="filter-container">
      <CustomDropdownFilter title="مرتب سازی براساس">
        <CustomView.Row>
          <CustomView.Column medium={12}>
            <p className="filter-labels">نوع کاربر:</p>
            {/* <CustomDropdownSearch
              items={ticketUserType}
              itemName="name"
              defaultItem={selectedUserType}
              onSelectItem={(event: any) => {
                setSelectedUserType(event);
                setRequestTicket!({
                  ...requestTicket,
                  filters: {
                    ...requestTicket?.filters,
                    type: event?._id,
                  },
                });
              }}
              placeHolder="انتخاب نوع کاربر"
              isLoading={getAllProvince.isLoading}
            /> */}
          </CustomView.Column>
          <CustomView.Column medium={12}>
            <p className="filter-labels">وضعیت تیکت:</p>
            {/* <CustomDropdownSearch
              items={TICKET_STATUS}
              itemName="name"
              defaultItem={selectedTicketStatus}
              onSelectItem={(event: any) => {
                setSelectedTicketStatus(event);
                setRequestTicket!({
                  ...requestTicket,
                  filters: {
                    ...requestTicket?.filters,
                    status: event?._id,
                  },
                });
              }}
              placeHolder="انتخاب وضعیت تیکت"
              isLoading={getAllProvince.isLoading}
            /> */}
          </CustomView.Column>
          <CustomView.Column medium={12}>
            <p className="filter-labels">استان:</p>
            {/* <CustomDropdownSearch
              items={getAllProvince?.data?.result}
              itemName="Name"
              defaultItem={requestTicket?.filters?.province}
              onSelectItem={(event: IProvinceItem) =>
                setRequestTicket!({
                  ...requestTicket,
                  filters: {
                    ...requestTicket?.filters,
                    province: event,
                    city: undefined,
                  },
                })
              }
              placeHolder="انتخاب استان"
              isLoading={getAllProvince.isLoading}
            /> */}
          </CustomView.Column>
          <CustomView.Column medium={12}>
            <p className="filter-labels">شهر:</p>
            {/* <CustomDropdownSearch
              items={getAllCity?.data?.result}
              itemName="Name"
              defaultItem={requestTicket?.filters?.city}
              onSelectItem={(event: ICityItem) =>
                setRequestTicket!({
                  ...requestTicket,
                  filters: {
                    ...requestTicket?.filters,
                    city: event,
                  },
                })
              }
              placeHolder="انتخاب شهر"
              isLoading={getAllCity.isLoading}
            /> */}
          </CustomView.Column>
        </CustomView.Row>
        <div className="filter-footer">
          <CustomButton2
            title="تنظیم مجدد"
            onClick={() => {
              setRequestTicket!({
                limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
                page: 1,
              });
            }}
            type="primary"
          />
        </div>
      </CustomDropdownFilter>
    </div>
  );

  // ?? -----------------------------------------------------------------------------------------------------------
  // ??                                             End JSX Content
  // ?? ===========================================================================================================
};

export default FilterSuperAgent;
